import classNames from 'classnames'
import { memo } from 'react'
import { MdSmartphone } from 'react-icons/md'
import { components } from 'react-select'

import type { ReactElement } from 'react'
import type { OptionProps, ControlProps } from 'react-select'
import type { IAppOption } from '~/types/option'

import AppLogo from '~/components/AppLogo'
import { resize } from '~/utils/media'

import './styles.scss'

export const formatAppOptionLabel = ({ label }: IOption): ReactElement => {
  return (
    <div className="option-label-custom-format">
      <div>{label}</div>
    </div>
  )
}

const CustomAppOption = memo(({ className, cx, data, innerProps, innerRef, isSelected }: OptionProps): ReactElement => {
  const { deviceType, label, url } = data as IAppOption

  return (
    <div {...innerProps} className={cx({ 'option-app': true }, className)} ref={innerRef}>
      {label !== 'All' ? (
        <AppLogo appLogoUrl={url ? resize(url, 48, 48) : undefined} appPlatform={deviceType} size="small" />
      ) : (
        <div />
      )}
      <div className={classNames('option-app-label', { selected: isSelected })} title={label}>
        {label}
      </div>
    </div>
  )
})

CustomAppOption.displayName = 'CustomAppOption'

export const CustomAppControl = ({ children, ...props }: ControlProps): ReactElement => {
  const selectedOption = props.getValue()[0] as { url?: string }

  return (
    <components.Control {...props} className="custom-app-control">
      {!selectedOption ? (
        <MdSmartphone className="fi" name="smartphone" size={20} />
      ) : (
        <AppLogo appLogoUrl={selectedOption.url} className="custom-app-control__app-logo" size="small" />
      )}
      {children}
    </components.Control>
  )
}

export default CustomAppOption
